import { renderRoutes } from 'react-router-config';
import pages from './pages';
import './services/firebase';
import runtimeConfig from './utils/runtime';

const project = runtimeConfig.RAZZLE_PROJECT || 'kiper';
// eslint-disable-next-line
require(`./assets/scss/main.${project}.scss`);

const App = () => renderRoutes(pages);

export default App;
